import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import MenuVertIcon from '../../icons/MenuVert';
import Menu from './B';


module.exports = (props) => {
  return (
    <div className="abs sv sr w50 layoutRow fhaC fvaC z1">
      <Menu
        transformOriginTop="right top"
        transformOriginBottom="right bottom"
        items={props.items || []}
      >
        <IconButton>
          <div className="sq23 layoutRow fhaC fvaC">
            <MenuVertIcon className="w4 cA3A7AC"/>
          </div>
        </IconButton>
      </Menu>
    </div>
  );
};
